export const getATCButtonsAndIds = async ({
  upsellWrapper,
}: {
  upsellWrapper: HTMLElement;
}) => {
  const upsellATCButtons = upsellWrapper?.querySelectorAll(
    '[data-node-type="commerce-add-to-cart-button"]'
  );

  if (upsellATCButtons)
    upsellATCButtons.forEach((element) => {
      element.setAttribute('data-fp', 'upsell-ATC');
    });

  const hotATCButtons = (document.querySelectorAll(
    '[data-node-type="commerce-add-to-cart-button"]:not([data-fp="upsell-ATC"])'
  ) as unknown) as HTMLElement[];

  const productIds: string[] = [];

  if (hotATCButtons) {
    hotATCButtons.forEach((element) => {
      const formElement = element.closest(
        '[data-node-type="commerce-add-to-cart-form"]'
      ) as HTMLElement;

      const productId = formElement?.getAttribute('data-commerce-product-id');

      if (productId) productIds.push(productId);
    });
  }

  return { hotATCButtons, productIds };
};
